import PropTypes from 'prop-types';
import { OptionPropTypes as sharedOptionPropTypes } from '../../shared/propTypes/common';

export const OptionPropTypes = sharedOptionPropTypes;

export const PeriodPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

export const TaxYearPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});
